import React, { useEffect, useState } from "react";

// Example : page id from facebook page
{/* <FBMessenger page_id="102670105728353" /> */
}
// the url of the domain must be added in the domain list of chat plugin in facebook
// chat plugin is not visible in localhost, use ngrok to get a url mapped with localhost and use that to view
export default function FBMessenger({ page_id }) {

    useEffect(() => {
        initFacebook();
    }, []);

    const initFacebook = () => {
        window.fbAsyncInit = function () {
            window.FB.init({
                xfbml: true,
                version: "v14.0",
            });
        };

        (function (d, s, id) {
            console.log("fb script");
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
            fjs.parentNode.insertBefore(js, fjs);

        })(document, "script", "facebook-jssdk");
    };
    return (
        <div>
            <div id="fb-root"></div>
            <div
                id="fb-customer-chat"
                page_id={page_id}
                className="fb-customerchat"
                attribution="biz_inbox"
            ></div>
        </div>
    );
}
